// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style_intervalIndicator__iEyi1 {
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: 600;
  border: 1px solid rgba(255, 255, 255, 0.3);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
  text-transform: uppercase;
  line-height: 1;
  cursor: pointer;
  z-index: 1000;
  flex-shrink: 0;
  pointer-events: auto;
  transition: transform 0.2s ease;
}

/* .intervalIndicator:hover {
  transform: scale(1.1);
} */
`, "",{"version":3,"sources":["webpack://./src/components/IntervalIndicator/style.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,0CAA0C;EAC1C,wCAAwC;EACxC,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,aAAa;EACb,cAAc;EACd,oBAAoB;EACpB,+BAA+B;AACjC;;AAEA;;GAEG","sourcesContent":[".intervalIndicator {\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  font-weight: 600;\n  border: 1px solid rgba(255, 255, 255, 0.3);\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);\n  text-transform: uppercase;\n  line-height: 1;\n  cursor: pointer;\n  z-index: 1000;\n  flex-shrink: 0;\n  pointer-events: auto;\n  transition: transform 0.2s ease;\n}\n\n/* .intervalIndicator:hover {\n  transform: scale(1.1);\n} */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"intervalIndicator": `style_intervalIndicator__iEyi1`
};
export default ___CSS_LOADER_EXPORT___;
